(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hover = window.matchMedia('(hover: hover)');
  function init(root = document) {
    root.querySelectorAll('[data-animated-logo]').forEach(mark => {
      if (mark.dataset.bound) return;
      mark.dataset.bound = 'true';
      const canvas = mark.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const sprite = new Image();
      let frame = 0, timer = 0, inside = false, ready = false;
      const count = Number(mark.dataset.frames);
      const draw = () => {
        ctx.clearRect(0, 0, 128, 160);
        ctx.drawImage(sprite, (frame % 10) * 128, Math.floor(frame / 10) * 160, 128, 160, 0, 0, 128, 160);
      };
      const stop = () => { clearInterval(timer); timer = 0; };
      const reset = () => { stop(); frame = 0; mark.classList.remove('is-ready'); };
      const start = () => {
        if (!ready || timer || !inside || !hover.matches || reduced.matches || document.hidden) return;
        draw();
        mark.classList.add('is-ready');
        timer = setInterval(() => { frame = (frame + 1) % count; draw(); }, 1000 / 24);
      };
      const enter = () => {
        inside = true;
        if (!sprite.src && hover.matches && !reduced.matches) sprite.src = mark.dataset.sprite;
        start();
      };
      sprite.onload = () => { ready = true; start(); };
      mark.addEventListener('mouseenter', enter);
      mark.addEventListener('mouseleave', () => { inside = false; reset(); });
      const visibility = () => document.hidden ? reset() : start();
      document.addEventListener('visibilitychange', visibility);
      const motion = () => { if (reduced.matches) reset(); else start(); };
      reduced.addEventListener('change', motion);
      const section = mark.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => {
        stop(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motion);
      }, { once: true });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
